import React from "react";
import GetInitials from "../GetInitials";
import { isEmpty } from "lodash";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WarningModal from "../WarningModal/WarningModal";
import { Link } from "react-router-dom";
import {
  FLOW_TYPES,
  getPathWithParam,
  LOAN_STATUS,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  ssnMasking,
  usCurrency,
  usDateFormat,
} from "../../utils";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import LoanEmployeeDetails from "../LoanSummaryCard/LoanEmployeeDetails";
import AddToolTip from "../AddToolTip/AddToolTip";

const LoanApprovalCard = ({ title, onClickOfCard }) => {
  return (
    <div
      className="loan-approval-card-container cursor-pointer mb-3"
      onClick={() => {
        onClickOfCard();
      }}
    >
      <div className="ft-10 d-flex justify-content-center approval-loan-status">
        {LOAN_STATUS[title.loanStatus] == "AwaitingApproval"
          ? "New loan request"
          : LOAN_STATUS[title.loanStatus] ==
            "ReAmortizationRequestAwaitingApproval"
          ? "Loan re-amortize"
          : "Loan refinance"}
      </div>
      <div className="d-flex align-items-center">
        <div className="mr-1 w-25">
          <LoanEmployeeDetails isLoanApproval={true} employeeInfo={title} />
        </div>
        <div className="w-15">
          <div className="ft-12 card-text-color mb-1">Plan Name</div>
          <div className="ft-12 fw-500 mb-1">
            <AddToolTip name={title?.planName} />
          </div>
        </div>
        <div className="w-10">
          <div className="ft-12 card-text-color mb-1">Plan ID</div>
          <div className="ft-12 fw-500 mb-1">{title?.planId ?? "-"}</div>
        </div>
        <div className="w-15">
          <div className="ft-12 card-text-color mb-1">Transaction ID</div>
          <div className="ft-12 fw-500 mb-1">
            {title?.loanIdentifier ?? "-"}
          </div>
        </div>
        <div className="w-15">
          <div className="ft-12 card-text-color mb-1">Amount</div>
          <div className="ft-12 fw-500 mb-1">
            {usCurrency(title?.requestedAmount)}
          </div>
        </div>
        <div className="w-15">
          <div className="ft-12 card-text-color mb-1">Loan type</div>
          <div className="ft-12 fw-500 mb-1">{title.loanType}</div>
        </div>
        <div className="w-15">
          <div className="ft-12 card-text-color mb-1">Request Date</div>
          <div className="ft-12 fw-500 mb-1">
            {usDateFormat(title.requestedDate)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanApprovalCard;
